<template>
  <div>
    <div style="text-align:left;">
      <router-link to="/adminhome"><< Back</router-link>
    </div>
    <table class="table table-stripe table-hover">
      <thead>
        <tr>
          <th># ID</th>
          <th>Config Key</th>
          <th>Config Value</th>
          <th>Description</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="config in sysConfigs">
          <td>{{config.id}}</td>
          <td>{{config.key}}</td>
          <td>
            <input type="text" class="form-control" v-model="config.value">
          </td>
          <td>{{config.description}}</td>
          <td>
            <button class="btn btn-primary" v-on:click="saveConfig(config)">Save</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data() {
    return {
      sysConfigs: []
    };
  },
  methods: {
    getSystemConfig: async function() {
      let response = await http.get("/systemconfig");
      this.sysConfigs = response.data;
    },
    saveConfig: async function(config) {
      try {
        let response = await http.patch("/systemconfig/" + config.id, config);
        alert(
          "Config Key '" +
            config.key +
            "' is saved with value '" +
            config.value +
            "' successfully!"
        );
      } catch (err) {
        alert(
          "Unable to save config key '" + config.key + "'. Please try again."
        );
      }
      this.getSystemConfig();
    }
  },
  beforeMount: async function() {
    this.getSystemConfig();
    if (!(await http.isLoggedIn(true))) {
      this.$router.push("/adminhome");
    }
  }
};
</script>

<style>
</style>
